module.exports = __webpack_public_path__ + "static/img/PW.051b3990.svg";